import React, {useMemo, useRef} from 'react'
import {ReactComponent as FaWalking} from '../../assets/icons/FaPersonWalking.svg'
import {ReactComponent as MdWatch} from '../../assets/icons/MdWatch.svg'

import {ReactComponent as SpatchIcon} from '../../assets/icons/S-Patch.svg'

import {ReactComponent as AppleWatchIcon} from '../../assets/icons/AppleWatchIcon.svg'
import {ReactComponent as SamsungLogo} from '../../assets/images/Samsung.svg'
import {ReactComponent as WellysisLogo} from '../../assets/images/Wellysis.svg'
import {ReactComponent as AppleLogo} from '../../assets/images/apple-logo-2.svg'
import KioskImage from '../../assets/images/kiosk.png'
import useWindowSize from '../../utils/useWindowSize'
import ExercisesChart from '../exercise/ExercisesChart'
import ExercisesTable from '../exercise/ExercisesTable'
import HealthStat from './HealthStat'

import {useSignal} from '@preact/signals-react'
import {useSignals} from '@preact/signals-react/runtime'
import {Message} from 'primereact/message'
import TranslateUtils from '../../i18n/TranslateUtils'
import Biometrics from '../biometrics/Biometrics'
import ECGChart from '../ecg/ECGChart'
import {brands, ECGDeviceTypes} from '../ecg/ECGConstants'
import ECGWrapper from '../ecg/ECGWrapper'
import DeviceActivitiesLog from '../exercise/DeviceActivitiesLog'
import HealthRecordChart from '../health-record-chart/HealthRecordChart'

const Statistic = (props, ref) => {
    useSignals()
    //#region Translate
    const {translateCommons} = TranslateUtils()
    //#endregion

    //#region Import
    const width = useWindowSize()
    //#endregion

    //#region Ref
    const refForm = useRef(null)
    //#endregion

    const initialActiveBrand = useMemo(() => {
        if (!props?.deviceBrand || !props?.deviceAssigned) return brands.samsung

        switch (props?.deviceBrand) {
            case ECGDeviceTypes.samsung:
                return brands.samsung
            case ECGDeviceTypes.apple:
                return brands.apple
            case ECGDeviceTypes.spatch:
                return brands.wellysis
            default:
                return brands.wellysis
        }
    }, [props?.deviceBrand, props?.deviceAssigned])

    //#region State
    const checked = useSignal(true)
    const activeBrand = useSignal(initialActiveBrand)
    //#endregion

    //#region Handle Function
    const handleToggleActivities = () => {
        checked.value = !checked.value
    }
    //#endregion
    //#region Memo
    const brandItemList = useMemo(() => {
        let list = []

        if (!!props?.deviceAssigned) {
            if (props?.deviceBrand === ECGDeviceTypes.samsung) {
                list.push({
                    label: translateCommons('Galaxy Watch'),
                    value: brands.samsung,
                    logo: SamsungLogo,
                    style: {width: '85px', height: '65px'},
                    icon: () => (
                        <MdWatch style={{width: '26px', height: '36px'}} />
                    ),
                    onclick: () => (activeBrand.value = brands.samsung),
                    deviceName:
                        (props?.deviceBrand === ECGDeviceTypes.samsung &&
                            props?.watchDeviceName) ||
                        '-',
                })
            }
            if (props?.deviceBrand === ECGDeviceTypes.apple) {
                list.push({
                    label: translateCommons('Apple Watch'),
                    value: brands.apple,
                    logo: AppleLogo,
                    style: {width: '80px', height: '26px'},
                    icon: () => (
                        <div style={{height: '40px'}}>
                            <AppleWatchIcon
                                style={{width: '28px', height: '36px'}}
                            />
                        </div>
                    ),
                    onclick: () => (activeBrand.value = brands.apple),
                    deviceName:
                        (props?.deviceBrand === ECGDeviceTypes.apple &&
                            props?.watchDeviceName) ||
                        '-',
                })
            }
        }

        return [
            ...list,

            {
                label: translateCommons('S-Patch'),
                value: brands.wellysis,
                logo: WellysisLogo,
                style: {width: '70px', height: '65px'},
                icon: () => (
                    <SpatchIcon style={{width: '30px', height: '40px'}} />
                ),
                onclick: () => (activeBrand.value = brands.wellysis),
                deviceName: props?.spatchDeviceName
                    ? `S/Number ${props?.spatchDeviceName}`
                    : '-',
            },
            {
                label: translateCommons('Fixed Kiosk'),
                value: brands.kiosk,
                altText: 'Kiosk',
                style: {width: '70px', height: '65px'},
                icon: () => (
                    <img
                        src={KioskImage}
                        style={{width: '50px', height: '40px'}}
                    />
                ),
                onclick: () => (activeBrand.value = brands.kiosk),
                deviceName: '-',
            },

            // {
            //     label: translateCommons('Smart Insoles'),
            //     value: brands.nurvv,
            //     logo: NurvvLogo,
            //     style: {width: '80px', height: '65px'},
            //     icon: () => (
            //         <IoFootstepsOutline style={{width: '24px', height: '36px'}} />
            //     ),
            //     onclick: () => activeBrand.value =(brands.nurvv),
            // },
            // {
            //     label: translateCommons('Sensor'),
            //     value: brands.prevayl,
            //     logo: PrevaylLogo,
            //     style: {width: '120px', height: '65px'},
            //     icon: () => (
            //         <GiMovementSensor style={{width: '24px', height: '36px'}} />
            //     ),
            //     onclick: () => activeBrand.value =(brands.prevayl),
            // },
        ]
    }, [
        props?.deviceAssigned,
        props?.spatchDeviceName,
        props?.deviceBrand,
        props?.watchDeviceName,
        translateCommons,
        activeBrand,
    ])
    //#endregion

    return (
        <div className="col-12 p-0">
            <div className="col-12 mb-5 p-0">
                <Biometrics ref={refForm} />
            </div>
            <div style={{height: '800px'}} className="mb-5">
                <HealthRecordChart />
            </div>
            <div className="col-12 p-0">
                <ul className="m-0 p-0">
                    <div className="flex mb-1 border-round justify-content-center align-items-center py-3 px-2 flex-wrap bg-teal-50 ">
                        <h5
                            className={`pl-2 text-darkcyan font-bold w-full m-0 py-2 text-center md:text-left`}>
                            <span className="mr-3">
                                <FaWalking
                                    style={{width: '20px', height: '20px'}}
                                />
                            </span>
                            {translateCommons('Wellness Activities')}
                        </h5>
                    </div>
                    <div className="col-12 mb-3">
                        <div
                            className="flex gap-3 overflow-x-auto"
                            style={{overflowY: 'hidden'}}>
                            {brandItemList?.map((item, index) => (
                                <div
                                    key={index}
                                    className="pointer"
                                    onClick={() =>
                                        item?.onclick ? item.onclick() : {}
                                    }
                                    style={{
                                        backgroundColor:
                                            activeBrand.value === item.value
                                                ? '#f9f9f9'
                                                : 'transparent',
                                        border: '0.5px solid lightgray',
                                        borderRadius: '8px',
                                        height: 180,
                                        width: 150,
                                    }}>
                                    <div className="flex flex-column align-items-center justify-content-center">
                                        <div
                                            className="flex flex-column align-items-center justify-content-center"
                                            style={{minHeight: '65px'}}>
                                            {item?.logo && (
                                                <item.logo
                                                    alt={item.label}
                                                    style={item?.style}
                                                />
                                            )}

                                            {item?.altText && (
                                                <div className="h-full text-center">
                                                    <h5
                                                        className="font-bold mb-0"
                                                        style={{
                                                            color: 'black',
                                                        }}>
                                                        {item.altText}
                                                    </h5>
                                                </div>
                                            )}
                                        </div>
                                        <div className="flex justify-content-center align-items-center mb-2">
                                            <div style={{height: '40px'}}>
                                                {!!item?.icon && item.icon()}
                                            </div>
                                        </div>
                                        <p className="font-bold mb-2">
                                            {' '}
                                            {item.label}
                                        </p>

                                        <p
                                            className="text-center"
                                            style={{fontSize: '12px'}}>
                                            <small className="text-center">
                                                {item?.deviceName}
                                            </small>
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </ul>
            </div>
            {activeBrand.value === brands.samsung && (
                <React.Fragment>
                    <div
                        className="col-12 p-0"
                        style={{minHeight: !checked.value ? '70vh' : '40vh'}}>
                        {!checked.value ? (
                            <ExercisesChart
                                isToggle={!checked.value}
                                onToggleActivities={handleToggleActivities}
                                type={ECGDeviceTypes.samsung}
                            />
                        ) : (
                            <div>
                                <div className="mb-5">
                                    <DeviceActivitiesLog />
                                </div>
                                <ExercisesTable
                                    isToggle={!!checked.value}
                                    onToggleActivities={handleToggleActivities}
                                    type={ECGDeviceTypes.samsung}
                                />{' '}
                            </div>
                        )}
                    </div>
                    <ECGWrapper type={ECGDeviceTypes.samsung} />
                </React.Fragment>
            )}

            {activeBrand.value === brands.apple && (
                <React.Fragment>
                    <div
                        className="col-12 p-0"
                        style={{minHeight: !checked.value ? '70vh' : '40vh'}}>
                        {!checked.value ? (
                            <ExercisesChart
                                isToggle={!checked.value}
                                onToggleActivities={handleToggleActivities}
                                type={ECGDeviceTypes.apple}
                            />
                        ) : (
                            <div>
                                <ExercisesTable
                                    isToggle={!!checked.value}
                                    onToggleActivities={handleToggleActivities}
                                    type={ECGDeviceTypes.apple}
                                />{' '}
                            </div>
                        )}
                    </div>
                    <ECGWrapper type={ECGDeviceTypes.apple} />
                </React.Fragment>
            )}

            {activeBrand.value === brands.wellysis && (
                <div className="col-12 p-0" style={{minHeight: '70vh'}}>
                    <li className="flex align-items-center py-3 flex-wrap col-12">
                        <div
                            className={`col-12 m-0 mb-1 p-0 flex align-items-center justify-content-center ${
                                width < 992 ? 'overflow-auto' : ''
                            }`}>
                            <ECGWrapper type={ECGDeviceTypes.spatch} />
                        </div>
                    </li>
                </div>
            )}

            {activeBrand.value === brands.kiosk && (
                <div className="col-12 p-0" style={{minHeight: '70vh'}}>
                    <li className="flex align-items-center py-3 flex-wrap col-12">
                        <div
                            className={`col-12 m-0 mb-1 p-0 flex align-items-center justify-content-center ${
                                width < 992 ? 'overflow-auto' : ''
                            }`}>
                            <Message
                                className="col-12"
                                severity="info"
                                text={'No data'}
                                style={{
                                    height: '50px',
                                }}
                            />
                        </div>
                    </li>
                </div>
            )}

            {activeBrand.value === brands.nurvv && (
                <div className="col-12 p-0" style={{minHeight: '70vh'}}>
                    <li className="flex align-items-center py-3 flex-wrap col-12">
                        <div
                            className={`col-12 m-0 mb-1 p-0 flex align-items-center justify-content-center ${
                                width < 992 ? 'overflow-auto' : ''
                            }`}>
                            <HealthStat />
                        </div>
                    </li>
                </div>
            )}

            {activeBrand.value === brands.prevayl && (
                <div className="col-12 p-0" style={{minHeight: '70vh'}}>
                    <li className="flex align-items-center py-3 flex-wrap col-12">
                        <div
                            className={`col-12 m-0 mb-1 p-0 flex align-items-center justify-content-center ${
                                width < 992 ? 'overflow-auto' : ''
                            }`}>
                            {/* <HealthStat /> */}
                        </div>
                    </li>
                    {/* <ECGRecordMonitor /> */}
                    <ECGChart />
                </div>
            )}
        </div>
    )
}

export default Statistic
